import getMatchedCountry from './get-matched-country';
import getSplitLocale from './get-split-locale';
/**
 * Given locale should be in xx_XX format.  Checks to see if countryCode
 * exists in locales array, and if so, if language code exists in
 * that country. getMatchedCountry searched locales obj from lib-locale
 * @param {string} locale e.g. "en_US"
 * @return {string|undefined} locale or undefined
 */
const getValidatedLocale = locale => {
  if (typeof locale === 'string') {
    const localeSplit = getSplitLocale(locale);
    // get country from locale
    if (localeSplit.length > 1) {
      const countryCode = localeSplit[1].toUpperCase();
      const lang = localeSplit[0].toLowerCase();
      const country = getMatchedCountry(countryCode);

      // does language exist in this country
      if (country) {
        const languages = country.languages;
        if (Array.isArray(languages) && languages.find(l => lang === l.code)) {
          return `${lang}_${countryCode}`;
        }
      }
    }
  }
  return undefined;
};

export default getValidatedLocale;
